export default __webpack_public_path__ + "static/media/bottom-right-trello.3a2e83ce.svg";